import React from 'react';
import { animated, useSpring } from '@react-spring/web';

const FadeInFromBottom = ({
  distance = 20,
  duration = 100,
  delay = 0,
  ...rest
}: {
  distance?: number;
  duration?: number;
  delay?: number;
  children?: React.ReactNode;
}) => {
  const styles = useSpring({
    from: {
      transform: `translateY(${distance}px)`,
      opacity: 0,
    },
    to: {
      transform: 'translateY(0px)',
      opacity: 1,
    },
    config: { duration },
    delay,
  });

  return <animated.div style={styles} {...rest} />;
};

export default FadeInFromBottom;
